import { render, staticRenderFns } from "./SystemSettingsView.vue?vue&type=template&id=0be022bc"
import script from "./SystemSettingsView.vue?vue&type=script&lang=js"
export * from "./SystemSettingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports